<!-- 信息认证 -->
<template>
<div class="" >
    <div class="detail-wrap">              
        <el-tabs v-model="activeName" type="border-card"  style="width:100%;min-height: 600px;">
            <el-tab-pane label="用户信息" name="first">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="姓名" prop="username"  >
                                <el-input v-model="ruleForm.username" placeholder="姓名" maxlength="10"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="手机号" prop="phone"  >
                                <el-input v-model="ruleForm.phone" @input="handlePhone"
                                    placeholder="手机号" maxlength="11"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="角色" prop="role" >
                                <el-select v-model="ruleForm.role" style="width:100%">
                                    <el-option
                                        v-for="item in roleOption"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        :disabled="item.disabled"
                                        >
                                        </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>                    
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="身份证正面" prop="imageUrl1" class="form" >
                        <el-upload class="avatar-uploader" 
                            ref="coverPicUpload1" action="" 
                            list-type="picture-card" accept="image/*"
                            multiple :limit="1" name="file" 
                            :show-file-list="false" 
                            :http-request="handleRequest1"
                            :before-upload="handleBeforeUpload" 
                            :on-error="handleUploadError">
                            <el-image v-if="!ruleForm.imageUrl1" :src="ruleForm.imageUrl1">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-plus" />
                            </div>
                            </el-image>
                            <div v-else class="image">
                            <el-image :src="ruleForm.imageUrl1" :style="`width:150px;height:150px;`" fit="fill" />
                            <div class="mask">
                                <div class="actions">
                                <span title="移除" @click.stop="handleRemove1">
                                    <i class="el-icon-delete" />
                                </span>
                                </div>
                            </div>
                            </div>
                        </el-upload>
                    </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="身份证反面" prop="imageUrl2" class="form" >
                        <el-upload class="avatar-uploader" 
                            ref="coverPicUpload2" action="" 
                            list-type="picture-card" accept="image/*"
                            multiple :limit="1" name="file" 
                            :show-file-list="false" 
                            :http-request="handleRequest2"
                            :before-upload="handleBeforeUpload" 
                            :on-error="handleUploadError">
                            <el-image v-if="!ruleForm.imageUrl2" :src="ruleForm.imageUrl2">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-plus" />
                            </div>
                            </el-image>
                            <div v-else class="image">
                            <el-image :src="ruleForm.imageUrl2" :style="`width:150px;height:150px;`" fit="fill" />
                            <div class="mask">
                                <div class="actions">
                                <span title="移除" @click.stop="handleRemove2">
                                    <i class="el-icon-delete" />
                                </span>
                                </div>
                            </div>
                            </div>
                        </el-upload>
                    </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="上传凭证" prop="imageUrl3" class="form" >
                        <el-upload class="avatar-uploader" ref="coverPicUpload3" action="" list-type="picture-card" accept="image/*"
                            multiple :limit="1" name="file" :show-file-list="false" :http-request="handleRequest3"
                            :before-upload="handleBeforeUpload" :on-error="handleUploadError">
                            <el-image v-if="!ruleForm.imageUrl3" :src="ruleForm.imageUrl3">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-plus" />
                            </div>
                            </el-image>
                            <div v-else class="image">
                            <el-image :src="ruleForm.imageUrl3" :style="`width:150px;height:150px;`" fit="fill" />
                            <div class="mask">
                                <div class="actions">
                                <span title="移除" @click.stop="handleRemove3">
                                    <i class="el-icon-delete" />
                                </span>
                                </div>
                            </div>
                            </div>
                        </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="裁判证样图" v-if="this.ruleForm.role === '3'">
                            <el-image :src="referUrl" :preview-src-list="exampleList1"></el-image>
                            <span>点击查看大图</span>
                        </el-form-item>
                        <el-form-item label="俱乐部或协会样图" v-if="this.ruleForm.role === '4' || this.ruleForm.role === '5'">
                            <el-image :src="clubUrl" :preview-src-list="exampleList2"></el-image>
                            <span>点击查看大图</span>
                        </el-form-item>
                        
                    </el-col>
                </el-row> 
                <el-form-item class="red">
                    *裁判：3张照片（可以不上传身份证正反面，3张裁判证相关的照片即可）。<br>
                    *俱乐部或者协会：法人身份证照片、营业执照复印件，盖公章。<br>
                    *评级资格及条件， 显示以平台最终审核为准。
                </el-form-item>
                <el-form-item>
                    <el-button type="info" round  style="width: 220px;"
                    @click="handleAuthed"  v-if="authed">{{ statusName }}</el-button>
                    <el-button type="primary" round  style="width: 220px;"
                    @click="submit('ruleForm')" v-else>提交</el-button>
                </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>  
    </div></div>
  </template>
  
<script>
export default {
    components: {
      
    },
    data() {
        return {
            activeName: 'first',
            loading: false,
            ruleForm: {
                username: '',
                phone: '',
                role:'',
                level: '',
                company:'',  
                imageUrl1: '',
                imageUrl2: '',      
                imageUrl3: '',      
            },
            rules: {
                username: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                    { min: 1, max: 11, message: '长度在 1 到 11 个字符', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 1, max: 16, message: '长度在 1 到 16 个字符', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { min: 3, max: 11, message: '长度在 11 位字符', trigger: 'blur' }
                ],
                varifyCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    { min: 3, max: 6, message: '长度在 3 到 6 个字符', trigger: 'blur' }
                ],
                role: [
                    { required: true, message: '请选择角色', trigger: 'change' },
                ],
                level: [
                    { required: true, message: '请选择等级', trigger: 'change' },
                ],  
                imageUrl1: [
                    { required: true, message: '请上传身份证正面', trigger: 'change' }
                ],
                imageUrl2: [
                    { required: true, message: '请上传身份证反面', trigger: 'change' }
                ],
            },
            pwType: 'text',
            pwKey: 0,
            roleOption: [],
            levelOption: [],
            imageRole: '',
            imageLevel: '',
            imageLisence: '',
            userData: [],
            authed: false,
            referUrl: 'http://139.196.214.81:8082/img/gdhatch/1723452343773.jpeg',
            clubUrl: 'http://139.196.214.81:8082/img/gdhatch/1723452448382.jpeg',
            exampleList1:[
                'http://139.196.214.81:8082/img/gdhatch/1723452343773.jpeg',
                'http://139.196.214.81:8082/img/gdhatch/1723452381012.jpeg',
            ],
            exampleList2:[
                'http://139.196.214.81:8082/img/gdhatch/1723452448382.jpeg',
                'http://139.196.214.81:8082/img/gdhatch/1723452491014.png',
            ],
            statusName: ''
        }
    },
    created() {
        this.getUserRole()
        // this.getUserLevel()    
        setTimeout(()=>{
            this.getAuthInfo()
        },100)        
    },
    mounted() {
           
    },
    computed: {
        title() {
            return this.$route.meta.title
        },
    },
    methods: {
        getAuthInfo() {
            let params = {
                opcode: this.$code.AuthQuery
            }
            // 查询账户信息
            this.$api.requestAPI(params).then(res => {
                if (res.IsSuccess) {                    
                    let result = res.Data.DataTable;
                    if(result.length > 0){
                        let list = result.map(item=>{
                        let role = this.roleOption.filter(i=>i.label == item['角色'])
                        // let level = this.levelOption.filter(i=>i.value == item['等级'])
                            return{
                                userId: item['会员账号'],
                                username: item['姓名'],
                                phone: item['手机号'],
                                role: role[0].value,
                                // level: level[0].value,
                                // company: item['公司'],
                                imageUrl1: item['凭证正面'],
                                imageUrl2: item['凭证背面'],   
                                imageUrl3: item['备注'],
                                status: item['状态'],   
                                                          
                            }
                        })  
                        this.ruleForm = list[0] 
                        this.ruleForm.imageUrl1 = this.$global.uploadUrl + list[0].imageUrl1
                        this.ruleForm.imageUrl2 = this.$global.uploadUrl + list[0].imageUrl2
                        this.ruleForm.imageUrl3 = this.$global.uploadUrl + list[0].imageUrl3
                        this.imageRole  = list[0].imageUrl1
                        this.imageLevel = list[0].imageUrl2
                        this.imageLisence = list[0].imageUrl3
                        this.authed = list[0].status === '已审核' || list[0].status === '待审核'
                        this.statusName = list[0].status
                    }                          
                }
            }).catch(err => {
                this.$message.error("登录失败，请重新登录")
            })
        },
        // 获取用户角色
        getUserRole(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 10,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.roleOption  = result.map(item=>{
                        return{
                            value: item['词条索引'],
                            label: item['中文描述'],
                            disabled: item['中文描述'] ==="选手" || item['中文描述'] ==="管理员" || item['中文描述'] ==="教练"
                        }
                    })

                    // this.roleOption = arr.filter(i => i.label !=="选手" && i.label !=="管理员")
                }
            })
        },        
         // 获取用户等级
         getUserLevel(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 19,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.levelOption = result.map(item=>{
                        return{
                            value: item['词条索引'],
                            label: item['中文描述']
                        }
                    })
                }
            })
        },
        submit(formName) {
            let { username, role, phone } = this.ruleForm;
            let {imageRole, imageLevel,imageLisence } = this
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let params = {
                        opcode: this.$code.Authentification,
                        v_name: username,
                        v_caption: username,
                        v_phone: phone,
                        v_company: '',
                        c_type: role,
                        i_starrating: 1,
                        i_voucher_up_image:  imageRole,
                        i_voucher_down_image: imageLevel,
                        //非必填字段 
                        i_avatar_image: '',
                        v_synopsis: '',   
                        v_details: '',
                        v_summary: imageLisence,                     
                    }
                    this.$api.requestAPI(params).then(res => {
                        if (res.IsSuccess) {
                            this.$message.success(res.Message)
                        } else {
                            this.$message.error(res.Message)
                        }
                    }).catch(err => {
                        this.$message.error(err)
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        pwInput(e) {
            if (e) {
                this.pwType = 'password'
            } else {
                this.pwKey++
                this.pwType = 'text'
            }
        },
        async handleRequest1(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.imageRole  = url
            this.ruleForm.imageUrl1 = this.$global.uploadUrl + url
            console.log(this.ruleForm.imageUrl1)
            this.loading.close();
            this.$refs.coverPicUpload1.clearFiles()
        },
        async handleRequest2(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.imageLevel  = url
            this.ruleForm.imageUrl2 = this.$global.uploadUrl + url
            console.log(this.ruleForm.imageUrl2)
            this.loading.close();
            this.$refs.coverPicUpload2.clearFiles()
        },
        async handleRequest3(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.imageLisence  = url
            this.ruleForm.imageUrl3 = this.$global.uploadUrl + url
            console.log(this.ruleForm.imageUrl3)
            this.loading.close();
            this.$refs.coverPicUpload3.clearFiles()
        },
        handleRemove1(file, fileList) {
            this.imageRole = ''
            this.ruleForm.imageUrl1 = ''
        },
        handleRemove2(file, fileList) {
            this.imageLevel = ''
            this.ruleForm.imageUrl2 = ''
        },
        handleRemove3(file, fileList) {
            this.imageLisence = ''
            this.ruleForm.imageUrl3 = ''
        },
        handleBeforeUpload() {
            this.loading = this.$loading({
                lock: true,
                text: "上传中",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.loading.close();
        },
        handleUploadError() {
            this.$message({
                type: "error",
                message: "上传失败",
            });
            this.loading.close();
        },
        handleAuthed(){
            if(this.statusName === '已审核'){
                this.$message.error("您已经认证过了！不需要重复认证")
            }else{
                this.$message.error("等待审核,请勿重复提交")
            }
            
        },
        handlePhone(value){
            const pattern = /^[0-9]\d*$/g
            if (pattern.test(value)) {
                // 双向绑定
                this.ruleForm.phone = value
            } else {
                // 输入值不为正整数，则从中提取出数字并拼接为字符串
                const num = value.match(/\d+/g)
                this.ruleForm.phone = num ? num.join('') : ''
            }
        }
    },       
  }
  </script>
  <style lang='scss' scoped>
  @import '@/assets/css/style.scss';
  
  .detail-wrap {
    width: 1000px;
    // margin-bottom:50px;
    min-height: 500px;
  }
  
  .title {
    padding: 0 0 10px 10px;
    font-size: 22px;
  }
  
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

// .avatar-uploader .el-upload:hover {
//   border-color: #409EFF;
// }

// .avatar-uploader-icon {
//   font-size: 28px;
//   color: #8c939d;
//   width: 150px;
//   height: 150px;
//   line-height: 150px;
//   text-align: center;
// }

// .avatar {
//   width: 150px;
//   height: 150px;
//   display: block;
// }
// .form>>>.el-upload {
//   border: 1px dashed #e1e1e1;
// }
.image {
  position: relative;

  .mask {
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all 0.3s;
  }

  &:hover .mask {
    opacity: 1;
  }
}
  </style>


// WEBPACK FOOTER //
// src/views/auth/authInfo.vue